<template>
  <a-popover trigger="click"  v-model="isMapShow">
    <!-- 地图 -->
    <a slot="content"><Map v-show="mapIconShow" v-bind:redIconPos="itemIdx"></Map></a>
    <!-- 地图图标 -->
    <a-button type="primary">
      <svg class="icon tuodiantu" aria-hidden="true" v-show="mapIconShow">
        <use xlink:href="#icon-tuodiantu"></use>
      </svg>
    </a-button>
  </a-popover>
</template>

<script>
import Map from './Map.vue'

export default {    
  components: {
        Map
    },
  props:[
    'mapShow',
    'idx',
    'microphone',
    'mapIcon'
  ],
  data() {
    return {
      visible: true,
      isMapShow: this.mapShow,
      itemIdx: this.idx,
      microphoneShow: this.microphone,
      mapIconShow: this.mapIcon
    };
  },
  methods: {
    hide() {
      this.visible = false;
    }
  },
};
</script>
<style>
    .map-icon{
        position:absolute;
        left:0.05rem;
        bottom:0.1rem;
    }
    .ant-popover{
      transform-origin: 50% 38px!important;
      width:1px;
      height:1.45rem;
    }
    .ant-btn{
        /* background-color: transparent!important;
        border:none!important;
        padding:0!important;
        height:0.16rem!important;
        position: absolute!important;
        left:0.1rem;
        bottom:0.15rem;
        z-index: 11;
        box-shadow:none!important; */
        background-color: transparent!important;
        border: none!important;
        padding: 0!important;
        height: 6%!important;
        width: 4%!important;
        position: absolute!important;
        left: 2%;
        bottom: 3%;
        z-index: 11;
        box-shadow: none!important;
    }
    .ant-popover-inner{
        background-color: transparent!important;
        box-shadow: none!important;

    }
    .ant-popover-arrow{
        border:none!important;
        box-shadow: none!important;
 
    }
    
</style>
